export type PackDropdownOption = {
  value: string;
  label: string;
};

export const quantityOptionsByPack: Record<string, PackDropdownOption[]> = {
  "4,8,12 Units Titration Packs": [
    { value: "180", label: "1 Box = 180 Cartridges (Up to 48 units/day)" },
    { value: "360", label: "2 Boxes = 360 Cartridges (Up to 96 units/day)" },
    { value: "540", label: "3 Boxes = 540 Cartridges (Up to 144 units/day)" },
  ],

  "4,8 Units Titration Packs": [
    { value: "180", label: "1 Box = 180 Cartridges (Up to 36 units/day)" },
    { value: "360", label: "2 Boxes = 360 Cartridges (Up to 72 units/day)" },
    { value: "540", label: "3 Boxes = 540 Cartridges (Up to 108 units/day)" },
  ],

  "8,12 Units Combo Packs": [
    { value: "180", label: "1 Box = 180 Cartridges (Up to 60 units/day)" },
    { value: "360", label: "2 Boxes = 360 Cartridges (Up to 120 units/day)" },
    { value: "540", label: "3 Boxes = 540 Cartridges (Up to 180 units/day)" },
  ],

  "4 Units Cartridges": [
    { value: "90", label: "1 Box = 90 Cartridges (Up to 12 units/day)" },
    { value: "180", label: "2 Boxes = 180 Cartridges (Up to 24 units/day)" },
    { value: "270", label: "3 Boxes = 270 Cartridges (Up to 36 units/day)" },
  ],

  "8 Units Cartridges": [
    { value: "90", label: "1 Box = 90 Cartridges (Up to 24 units/day)" },
    { value: "180", label: "2 Boxes = 180 Cartridges (Up to 48 units/day)" },
    { value: "270", label: "3 Boxes = 270 Cartridges (Up to 72 units/day)" },
  ],

  "12 Units Cartridges": [
    { value: "90", label: "1 Box = 90 Cartridges (Up to 36 units/day)" },
    { value: "180", label: "2 Boxes = 180 Cartridges (Up to 72 units/day)" },
    { value: "270", label: "3 Boxes = 270 Cartridges (Up to 108 units/day)" },
  ],
};

export const getQtyLabel = (packagingSize: string | undefined, qty: string | number | undefined): string => {
  if (!qty) return "N/A";
  const qtyStr = String(qty);
  if (packagingSize && quantityOptionsByPack[packagingSize]) {
    const match = quantityOptionsByPack[packagingSize].find((opt) => opt.value === qtyStr);
    if (match) return match.label;
  }
  return qtyStr;
};
